const EXPORT_LIMIT = 10000

const isPlainObject = (value) => {
  return Object.prototype.toString.call(value) === '[object Object]'
}

const flattenValue = (value, key, target) => {
  if (value === null || value === undefined) {
    target[key] = ''
    return
  }

  if (Array.isArray(value)) {
    if (value.length === 0) {
      target[key] = ''
      return
    }

    const hasNestedValues = value.some(item => Array.isArray(item) || isPlainObject(item))
    target[key] = hasNestedValues ? JSON.stringify(value) : value.join(', ')
    return
  }

  if (isPlainObject(value)) {
    const entries = Object.entries(value)

    if (entries.length === 0) {
      target[key] = ''
      return
    }

    entries.forEach(([nestedKey, nestedValue]) => {
      const composedKey = key ? `${key}.${nestedKey}` : nestedKey
      flattenValue(nestedValue, composedKey, target)
    })
    return
  }

  target[key] = value
}

export const flattenExportRecord = (record) => {
  if (!isPlainObject(record)) {
    return { value: record ?? '' }
  }

  const flattenedRecord = {}

  Object.entries(record).forEach(([key, value]) => {
    flattenValue(value, key, flattenedRecord)
  })

  return flattenedRecord
}

export const flattenExportRows = (records) => {
  if (!Array.isArray(records)) {
    return []
  }

  return records.map(flattenExportRecord)
}

export { EXPORT_LIMIT }
